module.exports = require('./bank-sync-abstract-item').extend({
    specialClasses: 'possible-subject',

    draggableHelperClass: 'male-left'
})
